module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/art-why-large-6dfb6cfecbf2bdf6485fd400195c6c26.jpg";